import React, { FC, Fragment, memo } from "react";

import { RichText } from "@montana/shared/rich-text";
import { IUSP, IM18USPPromoBar } from "@montana/models/generated/cms.interface";
import { Link } from "@montana/shared/link";
import { Media, MontanaMediaRatios } from '@montana/shared/media';
import { Appear } from "@montana/shared/appear";

export const M18UspBlock: FC<IM18USPPromoBar> = memo((props: IM18USPPromoBar): JSX.Element | null => {
    const {
        epiId,
        usPs,
        backgroundColorHex = '#F7F7F6'
    } = props;

    const renderUsp = (usp: IUSP, index: number) => (
        <div className="usp-block__usp" key={index}>
            <Appear>
                <div className="usp-block__usp-heading">
                    {usp.uspIcon && <Media className="usp-block__usp-image" image={usp.uspIcon} mediaRatio={MontanaMediaRatios.Landscape} placeholder={false} sizes="24px" />}
                    <RichText key={`usp-block__${epiId}__${index}`} text={usp.uspHeading || ''} disableAppear={true} />
                </div>
                <RichText key={`usp-block__${epiId}__${index}`} text={usp.uspText || ''} disableAppear={true} className="usp-block__usp-text" />
            </Appear>
        </div>
    )

    return usPs ? (
        <section className="usp-block" style={{ backgroundColor: backgroundColorHex }}>
            {usPs.map((usp: IUSP, index: number) => (
                <Fragment key={`usp-fragment-${index}`}>
                    {usp.uspLink ? (
                        <Link key={index} to={usp.uspLink}>
                            {renderUsp(usp, index)}
                        </Link>
                    ) : renderUsp(usp, index)}
                </Fragment>
            ))}
        </section>
    ) : null;
});
